/**
 * Calcul du salaire estimé du mois.
 *
 * Logique métier issue de la maquette d'origine :
 * - VRP (statut 'sal') : minimum garanti 1 850 €. Les commissions ne
 *   s'ajoutent au-dessus du seuil que lorsqu'elles le dépassent.
 *     - com < 1 850 €  →  salaire = 1 850 € (mini garanti seul)
 *     - com ≥ 1 850 €  →  salaire = com (= 1 850 mini + (com − 1 850) variable)
 * - MIA (statut 'mia') : pas de minimum, salaire = Σ commissions du mois.
 */

import type { StatutCode } from '../api/types';
import { fmtEur } from './format';

export const TARGET_MINIMUM_VRP = 1850;

export interface SalaryEstimation {
  total: number;
  subline: string; // libellé explicatif sous le titre
}

export function computeSalary(commissionMois: number, statut: StatutCode): SalaryEstimation {
  const isVRP = statut === 'sal';

  if (isVRP) {
    if (commissionMois < TARGET_MINIMUM_VRP) {
      return {
        total: TARGET_MINIMUM_VRP,
        subline: `${fmtEur(TARGET_MINIMUM_VRP)} minimum garanti · ${fmtEur(commissionMois)} de commissions`
      };
    }
    const variable = commissionMois - TARGET_MINIMUM_VRP;
    return {
      total: commissionMois,
      subline: `${fmtEur(TARGET_MINIMUM_VRP)} minimum garanti + ${fmtEur(variable)} variable`
    };
  }

  // MIA
  return {
    total: commissionMois,
    subline: 'Commissions cumulées · MIA'
  };
}
